import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents } from './components/PackContents';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
import { FretDivider } from './components/Ornaments';
import { FloatingWhatsApp } from './components/WhatsAppButton';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-6 text-center" data-id="element-0" data-mp="2wj8ehrfz0s5r">
    <FretDivider character="次" data-id="element-1" data-mp="28u5ysp4wd9dw" />
    <p className="mt-4 font-display text-xl font-bold italic leading-relaxed text-brand-burgundy/90 md:text-3xl" data-id="element-2" data-mp="28t4m6g88geu2">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="rice-paper min-h-screen font-sans text-brand-text selection:bg-brand-burgundy/20 selection:text-brand-burgundyDark" data-id="element-3" data-mp="3ij65gd4jrr9g">
      <UrgencyBanner data-id="element-4" data-mp="3mj6j3vjtnyfg" />
      <Hero data-id="element-5" data-mp="3rbr9en3irte8" />
      <PackContents data-id="element-6" data-mp="3rbzo8kj7d8s2" />
      <InitialTestimonials data-id="element-7" data-mp="3rdkl4gszp3t3" />
      <PainPoints data-id="element-8" data-mp="3recbnd7qcbci" />
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-9" data-mp="5ygolyg4xb6">
        <Pricing data-id="element-10" data-mp="82ld64660ci" />
      </div>
      <MoreTestimonials data-id="element-11" data-mp="2zld0l5ad579f" />
      <Guarantee data-id="element-12" data-mp="2zlv32jnmchps" />
      <FAQ data-id="element-13" data-mp="2zmem63p09c5e" />
      <TransitionPhrase data-id="element-14" data-mp="2zmwit1fkxsdu" />
      <EmotionalClose data-id="element-15" data-mp="33mouhn09senf" />
      <Footer data-id="element-16" data-mp="33m5ck6amdq9e" />
      <FloatingNotification data-id="element-17" data-mp="33nq73vwxp979" />
      <FloatingWhatsApp data-id="element-18" data-mp="33myn7icp8zwt" />
    </div>;
}